export const DIALOG_MODE_FAVORITES = 'favorites';

export const DIALOG_MODE_LOADING = 'loading';

export const DIALOG_MODE_REWARDS_SHOP = 'rewardsShop';

export const DIALOG_MODE_STANDARD_BUY = 'standardBuy';

export const DISCONTINUED = 'discontinued';

export const NOT_FOUND = 'notFound';

export const DIALOG_MODES = [
  DIALOG_MODE_FAVORITES,
  DIALOG_MODE_LOADING,
  DIALOG_MODE_REWARDS_SHOP,
  DIALOG_MODE_STANDARD_BUY,
  DISCONTINUED,
  NOT_FOUND,
];
